import React, { useState } from 'react';
import { submitInquiry } from '../config/api';

export default function ContactForm() {
	const [form, setForm] = useState({
		fullName: '',
		email: '',
		phone: '',
		shootType: '',
		preferredDate: '',
		message: '',
	});
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	const minDate = tomorrow.toISOString().split('T')[0];

	function set(key, value) {
		setForm(f => ({ ...f, [key]: value }));
		setErrors(e => ({ ...e, [key]: undefined }));
	}

	function validate() {
		const errs = {};
		if (!form.fullName || form.fullName.length < 2) {
			errs.fullName = 'Please enter your name';
		}
		if (!form.email || !form.email.includes('@')) {
			errs.email = 'Please enter a valid email';
		}
		if (!form.shootType) {
			errs.shootType = 'Please select a shoot type';
		}
		if (!form.preferredDate || form.preferredDate < minDate) {
			errs.preferredDate = 'Please choose a future date';
		}
		if (!form.message || form.message.length < 10) {
			errs.message = 'Message must be at least 10 characters';
		}
		return errs;
	}

	async function handleSubmit(e) {
		e.preventDefault();
		const errs = validate();
		if (Object.keys(errs).length) {
			setErrors(errs);
			return;
		}
		setLoading(true);
		setErrors({});
		setSuccess(false);
		try {
			await submitInquiry({
				full_name: form.fullName,
				email: form.email,
				phone: form.phone,
				shoot_type: form.shootType,
				preferred_date: form.preferredDate,
				message: form.message,
			});
			setSuccess(true);
			setForm({ fullName: '', email: '', phone: '', shootType: '', preferredDate: '', message: '' });
		} catch (err) {
			setErrors({ submit: 'Something went wrong. Please try again.' });
		} finally {
			setLoading(false);
		}
	}

	function inputStyle(hasError) {
		return {
			border: 'none',
			borderBottom: '1px solid ' + (hasError ? 'var(--color-error)' : 'var(--color-border)'),
			background: 'transparent',
			padding: '9px 0',
			fontSize: 13,
			color: 'var(--color-text)',
			outline: 'none',
			fontFamily: 'var(--font-body)',
			width: '100%',
		};
	}
	const labelStyle = {
		fontSize: 10,
		letterSpacing: '0.12em',
		textTransform: 'uppercase',
		color: 'var(--color-muted)',
		display: 'block',
		marginBottom: 7,
		fontFamily: 'var(--font-body)',
	};
	const errStyle = {
		fontSize: 11,
		color: 'var(--color-error)',
		marginTop: 4,
		fontFamily: 'var(--font-body)',
	};

	return (
		<form onSubmit={handleSubmit} noValidate>
			{success && (
				<div style={{ background: '#f0fff4', borderLeft: '3px solid var(--color-success)', padding: '14px 16px', fontSize: 13, color: '#1a5c34', marginBottom: 24, fontFamily: 'var(--font-body)' }}>
					Thank you! I'll be in touch within 48 hours. 🌸
				</div>
			)}
			{errors.submit && (
				<div style={{ background: '#fff5f5', borderLeft: '3px solid var(--color-error)', padding: '14px 16px', fontSize: 13, color: '#7f1d1d', marginBottom: 24, fontFamily: 'var(--font-body)' }}>
					{errors.submit}
				</div>
			)}
			<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
				<div>
					<label style={labelStyle}>FULL NAME *</label>
					<input type="text" value={form.fullName} onChange={e => set('fullName', e.target.value)} style={inputStyle(errors.fullName)} placeholder="Priya Sharma" />
					{errors.fullName && <p style={errStyle}>{errors.fullName}</p>}
				</div>
				<div>
					<label style={labelStyle}>EMAIL ADDRESS *</label>
					<input type="email" value={form.email} onChange={e => set('email', e.target.value)} style={inputStyle(errors.email)} placeholder="priya@example.com" />
					{errors.email && <p style={errStyle}>{errors.email}</p>}
				</div>
			</div>
			<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
				<div>
					<label style={labelStyle}>PHONE (OPTIONAL)</label>
					<input type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} style={inputStyle(false)} placeholder="+91 98765 43210" />
				</div>
				<div>
					<label style={labelStyle}>SHOOT TYPE *</label>
					<select
						value={form.shootType}
						onChange={e => set('shootType', e.target.value)}
						style={{
							...inputStyle(errors.shootType),
							background: 'var(--color-bg)',
							color: 'var(--color-text)',
							cursor: 'pointer'
						}}
					>
						<option value="" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Select...</option>
						<option value="Portrait" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Portrait</option>
						<option value="Maternity" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Maternity</option>
						<option value="Newborn" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Newborn</option>
						<option value="Family" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Family</option>
						<option value="Couples" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Couples</option>
						<option value="Other" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>Other</option>
					</select>
					{errors.shootType && <p style={errStyle}>{errors.shootType}</p>}
				</div>
			</div>
			<div>
				<label style={labelStyle}>PREFERRED DATE *</label>
				<div style={{ position: 'relative' }}>
					<input
						type="date"
						value={form.preferredDate}
						min={minDate}
						onChange={e => set('preferredDate', e.target.value)}
						ref={dateInputRef => {
							if (dateInputRef) {
								dateInputRef.addEventListener('click', (e) => {
									e.target.showPicker?.();
								});
							}
						}}
						style={{
							...inputStyle(errors.preferredDate),
							cursor: 'pointer',
							colorScheme: 'dark',
							opacity: form.preferredDate ? 1 : 0,
							position: form.preferredDate ? 'relative' : 'absolute',
							pointerEvents: form.preferredDate ? 'auto' : 'none'
						}}
					/>
					{!form.preferredDate && (
						<button
							type="button"
							onClick={(e) => {
								const input = e.currentTarget.previousElementSibling;
								input.focus();
								input.showPicker?.();
							}}
							style={{
								...inputStyle(errors.preferredDate),
								cursor: 'pointer',
								background: 'transparent',
								textAlign: 'left',
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
								color: 'var(--color-muted)'
							}}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								stroke="var(--color-muted)"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							>
								<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
								<line x1="16" y1="2" x2="16" y2="6"></line>
								<line x1="8" y1="2" x2="8" y2="6"></line>
								<line x1="3" y1="10" x2="21" y2="10"></line>
							</svg>
							Click to select date
						</button>
					)}
				</div>
				{errors.preferredDate && <p style={errStyle}>{errors.preferredDate}</p>}
			</div>
			<div>
				<label style={labelStyle}>MESSAGE *</label>
				<textarea value={form.message} maxLength={1000} onChange={e => set('message', e.target.value)} style={{ ...inputStyle(errors.message), resize: 'none', height: 80 }} placeholder="Tell me about the shoot you have in mind..." />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
					{errors.message ? <p style={errStyle}>{errors.message}</p> : <span></span>}
					<span style={{ color: 'var(--color-muted)' }}>{form.message.length}/1000</span>
				</div>
			</div>
			<button
				type="submit"
				disabled={loading}
				style={{
					width: '100%',
					padding: 14,
					background: loading ? 'var(--color-muted)' : 'var(--color-accent)',
					color: '#fff',
					border: 'none',
					fontSize: 11,
					letterSpacing: '0.1em',
					textTransform: 'uppercase',
					cursor: loading ? 'not-allowed' : 'pointer',
					fontFamily: 'var(--font-body)',
					marginTop: 8,
					borderRadius: 'var(--border-radius)',
				}}
			>
				{loading ? 'Sending...' : 'Send Message →'}
			</button>
		</form>
	);
}
